var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo clickable"},[_c('img',{staticClass:"px-2 py-1 d-block m-auto",attrs:{"src":_vm.$icons.Logo,"alt":"JokeTrip"}})])}
var staticRenderFns = []

export { render, staticRenderFns }